import Component from '../../../assets/scripts/modules/component';
import State from '../../../assets/scripts/modules/state';


class MenuBar extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.buttonToggleOpen = this.element.querySelector('[data-role=button--toggle-open]');
    this.buttonToggleSearch = this.element.querySelector('[data-role=button--toggle-search]');
    this.searchBar = this.element.querySelector('[data-role=search-bar]');
    this.searchInput = this.searchBar.querySelector('[data-role=search-input]');

    // add listeners
    this.buttonToggleOpen.addEventListener('click', this.onToggleOpen.bind(this));
    this.buttonToggleSearch.addEventListener('click', this.onToggleSearch.bind(this));

    this.searchBar.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', this.onClickOutside.bind(this));

    window.addEventListener('menu-bar:enable-dots', () => {
      this.element.classList.add('menu-bar--dotted');
    });

    window.addEventListener('menu-bar:disable-dots', () => {
      this.element.classList.remove('menu-bar--dotted');
    });
  }

  onToggleOpen(event) {
    event.preventDefault();

    this.element.classList.toggle('is-open');

  }

  onToggleSearch(event) {
    if (!State.isLandscape()) {
      return;
    }

    event.preventDefault();

    // show searchbar
    this.searchBar.classList.add('is-visible');
    this.searchBar.classList.remove('is-closing');
    this.searchInput.value = '';

    // set focus to searchform
    setTimeout(() => {
      this.searchInput.focus();
    }, 400);

    event.stopPropagation();
  }

  onClickOutside() {
    this.searchBar.classList.add('is-closing');

    setTimeout(() => {
      this.searchBar.classList.remove('is-visible');
    }, 250);
  }
}

for (const element of document.querySelectorAll('.menu-bar')) {
  element.instance = new MenuBar('menu-bar', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/structures/menu-bar/menu-bar.js